import {
  Component,
  Input,
  Output,
  EventEmitter,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core'
import { ProductData } from '../../types/products'

import { FormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatIcon } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatPaginatorModule } from '@angular/material/paginator'
import { MatSelectModule } from '@angular/material/select'
import { MatTableModule } from '@angular/material/table'
import { TranslationService } from '../../services/translation.service'
import { RouterModule } from '@angular/router'
import { MatTooltip } from '@angular/material/tooltip'
import { MatSlideToggle } from '@angular/material/slide-toggle'
import { MatDialogModule, MatDialog } from '@angular/material/dialog'
import { ShareProductsDialogComponent } from './share-products-dialog/share-products-dialog.component'

@Component({
  selector: 'app-product-list',
  imports: [
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatTableModule,
    MatPaginatorModule,
    FormsModule,
    MatIcon,
    RouterModule,
    MatTooltip,
    MatSlideToggle,
    MatDialogModule,
  ],
  templateUrl: './product-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./product-list.component.scss'],
})
export class ProductListComponent {
  translationService = inject(TranslationService)
  private dialog = inject(MatDialog)
  private matDialog = inject(MatDialog)

  @Input({ required: true }) products: ProductData[] = []
  @Input({ required: true }) displayedColumns: string[] = []
  @Input() showCloneButton: boolean = false
  @Input() shouldShowCopiedIcons: boolean = false
  @Input() shouldShowDiscontinued: boolean = false
  @Input() shouldShowShareProducts: boolean = false
  @Output() addToCatalogue = new EventEmitter<ProductData>()
  @Output() toggleDiscontinue = new EventEmitter<{
    productId: string
    discontinued: boolean
  }>()

  shouldShowAddToCatalogue(): boolean {
    return this.displayedColumns.includes('addToCatalogueAction')
  }

  /**
   * Opens the share dialog for the selected product.
   * @param {ProductData} product The product to share.
   * @returns {void}
   */
  onShareClick(product: ProductData): void {
    this.matDialog.open(ShareProductsDialogComponent, {
      data: {
        productId: product.id,
        productName: product.name,
      },
      maxWidth: '900px',
      width: '100%',
    })
  }
}
